export class AppointmentDate {
  constructor(
    public day: number,
    public month: number,
    public year: number
  ) {
  }

  static MapFromDate(d: Date): AppointmentDate {
    if (d) {
      return new AppointmentDate(d.getDate(), d.getMonth() + 1, d.getFullYear());
    }
    else {
      var today = new Date();
      return new AppointmentDate(today.getDate(), today.getMonth() + 1, today.getFullYear());
    }
  }

}
